import type { MatchItem } from './scoring-types';

export interface MatchRun {
  number: number;
  matches: MatchItem[];
  playedCount: number;
}

export function runLabel(run: MatchRun): string {
  const missing = run.matches.length - run.playedCount;

  if (missing === 0) {
    return `Runda ${run.number} · komplet wyników`;
  }

  return `Runda ${run.number} · brakuje ${missing} z ${run.matches.length}`;
}

// Kolejka rotacyjna dokłada rundy w trakcie gry, więc płaska lista meczów kłamie:
// świeżo rozdana runda wygląda w niej jak zapomniane wyniki. Null = zwykła
// kolejka, rozpisana raz i bez numerów rund.
export function runsOfMatches(matches: MatchItem[]): MatchRun[] | null {
  if (!matches.some((match) => typeof match.runNumber === 'number')) {
    return null;
  }

  const byNumber = new Map<number, MatchItem[]>();
  for (const match of matches) {
    const number = match.runNumber ?? 0;
    byNumber.set(number, [...(byNumber.get(number) ?? []), match]);
  }

  return Array.from(byNumber.entries())
    .sort(([first], [second]) => second - first)
    .map(([number, matchesInRun]) => ({
      number,
      matches: matchesInRun,
      playedCount: matchesInRun.filter((match) => match.winnerSide !== null).length,
    }));
}
